import styled from 'styled-components';

import { token } from '@zillow/constellation';

export const StyledAccountSettingsContainer = styled.div`
    background: ${token('colors.white')};
    margin-bottom: 20px;
    border: 1px solid ${token('colors.gray300')};
    border-radius: 5px;
`;
